export default {
  lifeYoung: `Pour rappel, dans le cadre du contrat d'assurance vie LCL Vie Jeunes, les versements réalisés pour une année civile ne doivent pas dépasser 5 000 € (frais sur versements inclus), à l'exception des versements issus de capitaux d'assurance vie dont l'assuré serait bénéficiaire en cas de décès.`,
  monthlyBuyout:
    'Des rachats programmés sont actuellement en place sur ce contrat pour les fonds :',
}
